export const CHECKBOX_WIDTH = 16;
export const NAME_WIDTH = 240;
export const JOB_WIDTH = 160;
